import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import HotelFacilityList from './HotelFacilityList';
import HotelFacilityUpdate from './HotelFacilityUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsFacilityHotelStore'
)
@observer
class HotelFacilityPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsFacilityHotelStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsFacilityHotelStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsFacilityHotelStore.setshowModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showModal,
            modalTitle
        } = this.props.CmsFacilityHotelStore;

        return (
            <MainContainer title={t('Hotel Facility Management')} menukey='facilities'>
                <Modal
                    title={t(modalTitle)}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <HotelFacilityUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <HotelFacilityList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(HotelFacilityPage);